import Swiper from "swiper";
import { Autoplay, EffectFade, Navigation, FreeMode, Thumbs } from "swiper/modules";
import "swiper/css";

export const slider = (): void => {
  const seminarSliderElm = document.querySelector(".p-seminar-slider");
  if (seminarSliderElm) {
    const seminarSliderElement = seminarSliderElm as HTMLElement;
    // const seminarSliderLength = seminarSliderElement.dataset.swiperLength;
    const seminarSlider = new Swiper(seminarSliderElement, {
      loop: true,
      slidesPerView: 2,
      spaceBetween: 0,
      navigation: {
        nextEl: ".p-seminar-slider__control.--next",
        prevEl: ".p-seminar-slider__control.--prev",
      },
      breakpoints: {
        600: {
          slidesPerView: 4,
        },
      },
    });
  }
};
